

































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import { synRuleDrawEnhance } from '../../services/free-order'
import { getPrizeDialogInfo } from '../../utils/free-order'
import RainDialog from './rain-dialog.vue'

const actModule = namespace('freeOrder')

@Component({
  name: 'game',
  components: {
    RainDialog
  }
})
export default class Game extends Vue {
  @actModule.State runConf!: any
  @Prop(Boolean) value!: boolean
  @Prop(String) type!: string
  get run() {
    return this.runConf.run || false
  }
  windowWidth = 375
  windowHeight = 667
  gameLayout = {}
  time = 15
  tickerId = -1
  map1 = []
  map2 = []
  currentMap = {
    y: -100
  }
  nextMap = {
    y: -200
  }
  resetData = {
    y: -100
  }
  speed = 6
  goldNum = 0
  status = 0 // 0待进入、1倒计时、2进入游戏、3游戏结束
  showResult = false
  cashValue = 0
  goldValue = 0
  updateStage = () => {}
  progress = 0
  prizeList = []
  mounted() {
    this.setLayout()
  }
  onImgLoad() {
    this.progress++
    if (this.progress === 4) {
      this.$Collect.trackView('2020双12红包雨页面_浏览', {}, {
        page_name: '双12红包雨页面'
      })
      setTimeout(() => {
        this.gameInit()
      }, 300)
    }
  }
  setLayout() {
    const self = this
    self.gameLayout = {
      width: `${window.innerWidth}px`,
      height: `${window.innerHeight}px`
    }
    this.windowWidth = window.innerWidth
    this.windowHeight = window.innerHeight
  }
  setElfStyle(item: any) {
    return {
      top: item.top + 'px',
      left: item.left + 'px'
    }
  }
  stopPenetrate() {
    return false
  }
  close() {
    const { x, y } = this.runConf
    this.$emit('input', false)
    this.status = 0
    this.progress = 0
    this.showResult = false
    this.$store.commit('freeOrder/updateRunConf', {
      run: false,
      ruleGroupCode: '',
      uiComponentCode: ''
    })
    if (!!x && !!y) {
      this.$store.commit('freeOrder/updateFireXYZ', { x, y })
    } else {
      this.$store.dispatch('freeOrder/bootUser', { force: true })
    }
  }
  gameInit() {
    this.status = 1
    this.currentMap.y = -this.windowHeight
    this.nextMap.y = -this.windowHeight * 2
    this.resetData.y = -this.windowHeight
    this.goldNum = 0
    this.createMap('map1')
    this.createMap('map2')
  }
  countDownEnd() {
    this.status = 2
    this.play()
  }
  play() {
    const setIn = setInterval(() => {
      if (this.time === 0) {
        clearInterval(setIn)
        this.complete()
      } else {
        this.time--
      }
    }, 1000)
    this.ticker(this.moveMap)
  }
  createMap(mapName: string) {
    const elfs: any = []
    const nums = Math.floor(Math.random() * 4) + 5 // 5到9个
    const me = Math.floor(this.windowHeight / nums)
    const grid = Math.floor((this.windowWidth - 20) / nums)

    for (let i = 0; i < nums; i++) {
      const type = Math.floor(Math.random() * 2) + 1
      const pm = Math.random() < 0.5 ? -1 : 1
      const top = me * i
      const left = (grid * Math.floor(Math.random() * nums)) + (pm * 10)
      elfs.push({ top, left, type, clicked: false })
    }

    (this as any)[mapName] = elfs
  }
  moveMap() {
    const self: any = this
    const limit = this.windowHeight
    self.currentMap.y += this.speed
    self.nextMap.y += this.speed
    if (this.time <= 0) {
      if (this.currentMap.y >= limit && this.nextMap.y >= limit) {
        this.gameEnd()
      }
    } else {
      if (this.currentMap.y >= limit) {
        this.currentMap.y = self.resetData.y
        this.createMap('map1')
      }
      if (this.nextMap.y >= limit) {
        this.nextMap.y = self.resetData.y
        this.createMap('map2')
      }
    }
  }
  ticker(draw: Function) {
    if (window.requestAnimationFrame) {
      this.updateStage = (gap?: number) => {
        draw(gap)
        window.requestAnimationFrame(this.updateStage)
      }
      this.updateStage()
    } else {
      this.tickerId = setInterval(() => {
        draw()
      }, 16.7)
    }
  }
  stopTicker() {
    this.updateStage = () => {}
    clearInterval(this.tickerId)
  }
  gameEnd() {
    this.stopTicker()
    this.status = 3
    this.time = 15
    this.draw()
  }
  complete() {
    console.log('红包点击数：', this.goldNum)
    this.$ssvue.toast.show('游戏结束')
  }
  draw() {
    const { ruleGroupCode, uiComponentCode } = this.runConf as any
    const param = {
      ruleGroupCodes: [ruleGroupCode],
      uiComponentCodes: [uiComponentCode],
      extParams: {
        clickNo: this.goldNum + ''
      }
    }
    synRuleDrawEnhance(param)
      .then((res: any) => {
        if (res.resultCode === '000000') {
          this.prizeList = getPrizeDialogInfo(res)
          this.showResult = true
          if (this.goldNum >= 20) {
            this.$Collect.trackView('2020双12红包雨页面_大于等于20次弹窗_浏览', {}, {
              page_name: '双12红包雨页面'
            })
          } else {
            this.$Collect.trackView('2020双12红包雨页面_小于20次弹窗_浏览', {}, {
              page_name: '双12红包雨页面'
            })
          }
        } else {
          let msg = '抽奖失败'
          res.resultCode === '100000' && (msg = '活动不存在或已过期')
          res.resultCode === '200000' && (msg = '无效的奖池')
          res.resultCode === '600000' && (msg = '无抽奖资格')
          res.resultCode === '600001' && (msg = '无效的规则')
          res.resultCode === '600002' && (msg = '非目标客群')
          res.resultCode === '600003' && (msg = '重复参与')
          res.resultCode === '800001' && (msg = '请求重复')
          this.errorToast(msg)
        }
      })
      .catch((error: any) => {
        this.errorToast(error.msg)
      })
  }
  errorToast(msg: string) {
    this.$ssvue.toast.show(msg)
    setTimeout(() => {
      this.close()
    }, 2000)
  }
  elfClick(order: any, index: number) {
    (this as any)[`map${order}`][index].clicked = true
    this.goldNum += 1
  }
}
